import React, { Component } from "react";
import styles from "./styles.module.scss";
import PropTypes from "prop-types";

import { ReactComponent as AccorCloseIcon } from "./images/AccorCloseIcon.svg";
import { ReactComponent as ArrowDownIcon } from "./images/ArrowDownIcon.svg";
import { ReactComponent as BackIcon } from "./images/BackIcon.svg";
import { ReactComponent as CheckboxTickIcon } from "./images/CheckboxTickIcon.svg"
import { ReactComponent as CloseIcon } from "./images/CloseIcon.svg";
import { ReactComponent as CRSIcon } from "./images/CRSIcon.svg";
import { ReactComponent as DeclareIcon } from "./images/DeclareIcon.svg";
import { ReactComponent as MobileFrame } from "./images/MobileFrame.svg";
import { ReactComponent as PersonalIcon } from "./images/PersonalIcon.svg";
import { ReactComponent as TooltipIcon } from "./images/TooltipIcon.svg";
class SDKPreview extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  hexToRgb(hex) {
    let color = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    let colorInRGB = !!color
      ? {
          r: parseInt(color[1], 16),
          g: parseInt(color[2], 16),
          b: parseInt(color[3], 16)
        }
      : null;

    return colorInRGB;
  }
  rgbToHex(rgb) {
    return "#" + ((1 << 24) + (rgb.r << 16) + (rgb.g << 8) + rgb.b).toString(16).slice(1);
  }

  textColorByGamma(hex) {
    let colorInRGB = this.hexToRgb(hex);
    if (!!colorInRGB) {
      let gammaVal =
        colorInRGB.r * 0.299 + colorInRGB.g * 0.587 + colorInRGB.b * 0.114;
      if (gammaVal < 186) {
        return "#ffffff";
      }
      return "#333333";
    }
    return "#333333";
  }

  lighten(hex,value) {
    let colorInRGB = this.hexToRgb(hex);
    colorInRGB.r += value;
    colorInRGB.g += value;
    colorInRGB.b += value;
    if(colorInRGB.r > 255){colorInRGB.r = 255}
    if(colorInRGB.g > 255){colorInRGB.g = 255}
    if(colorInRGB.b > 255){colorInRGB.b = 255}
    return this.rgbToHex(colorInRGB);
  }

  render() {
    return (
      <div className={styles.main}>
        <div className={styles.frame}>
          <MobileFrame/>
        </div>
        <div className={styles.wrapper}>
          <div className={styles.preHeader}></div>
          {/* Header */}
          <div
            className={styles.header}
            style={{
              backgroundColor: this.props.primaryColor,
              borderBottomColor: this.props.secondaryColor
            }}
          >
            <div
              className={styles.headerBack}
              style={{
                fill: this.textColorByGamma(this.props.primaryColor)
              }}
            >
              <BackIcon />
            </div>
            <div
              className={styles.headerTitle}
              style={{
                color: this.textColorByGamma(this.props.primaryColor)
              }}
            >
              Virtual Credit Card
            </div>
            <div
              className={styles.headerClose}
              style={{
                fill: this.textColorByGamma(this.props.primaryColor)
              }}
            >
              <CloseIcon />
            </div>
          </div>
          {/* Steps */}
          <div className={styles.stepSection}>
            <div className={styles.progressBar}>
              <div className={styles.progressBarInner}>
                <div className={styles.progressBarInnerStep}>STEP</div>
                <div className={styles.progressBarInnerCounter}>5 of 6</div>
              </div>
              <div className={styles.progressBarLeftPanel}>
                <div
                  className={styles.progressBarPanelInner}
                  style={{
                    backgroundColor: this.props.formElemColor
                  }}
                ></div>
              </div>
              <div className={styles.progressBarRightPanel}>
                <div
                  className={styles.progressBarPanelInner}
                  style={{
                    backgroundColor: this.props.formElemColor
                  }}
                ></div>
              </div>
            </div>
            <div className={styles.stepInfo}>
              <div className={styles.stepInfoTitle}>
                Review &#38; Sign Application
              </div>
              <div className={styles.stepInfoNext}>
                Next: Submit Income Documents
              </div>
            </div>
          </div>
          {/* Logo */}
          <div className={styles.logoSection}>
            <div className={styles.container}>
              <div className={styles.logoWrapper}>
                Partnership with
                <img src={this.props.logo} />
              </div>
            </div>
          </div>
          {/* Accordian */}
          <div className={styles.accorSection}>
            <div className={styles.accorHeader}>
              <div className={styles.accorHeaderTitle}>
                <div
                  className={styles.accorHeaderTitleIcon}
                  style={{
                    fill: this.props.formElemColor
                  }}
                >
                  <PersonalIcon />
                </div>
                Personal Information
              </div>
              <div className={styles.accorHeaderArrow}>
                <ArrowDownIcon />
              </div>
            </div>
            <div className={styles.accorHeader}>
              <div className={styles.accorHeaderTitle}>
                <div
                  className={styles.accorHeaderTitleIcon}
                  style={{
                    fill: this.props.formElemColor,
                    stroke: this.props.formElemColor
                  }}
                >
                  <DeclareIcon />
                </div>
                Declare &#38; Acknowledge
              </div>
              <div className={`${styles.accorHeaderArrow} ${styles.rotated}`}>
                <ArrowDownIcon />
              </div>
            </div>
            <div className={styles.accorBody}>
              <div
                className={styles.accorBodyClose}
                style={{
                  fill: this.props.formElemColor
                }}
              >
                <AccorCloseIcon />
              </div>
              <div className={styles.accorBodyContent}>
                <div className={styles.inputBlock}>
                  <div className={styles.checkboxBlock}>
                    <div
                      className={styles.checkbox}
                      style={{
                        fill: this.props.formElemColor
                      }}
                    >
                      <CheckboxTickIcon />
                    </div>
                    <div className={styles.checkboxLabel}>
                      I declare that I am NOT a&nbsp;
                      <a
                        style={{
                          color: this.lighten(this.props.formElemColor, 40)
                        }}
                      >
                        U.S. Citizen
                      </a>
                    </div>
                  </div>
                </div>
                <div className={styles.inputBlock}>
                  <div className={styles.inputLabelBold}>
                    Personal Data Usage Consent
                    <div 
                      className={styles.inputLabelTooltip}
                      style={{
                        fill: this.props.formElemColor
                      }}
                    >
                      <TooltipIcon/>
                      Info
                    </div>
                  </div>
                  <div className={styles.switchBlock}>
                    <div 
                      className={styles.switchButton}
                      style={{
                        color: this.props.formElemColor,
                        borderColor: this.props.formElemColor,
                        backgroundColor: `${this.props.formElemColor}1a`
                      }}
                    >
                      Yes
                    </div>
                    <div className={styles.switchButton}>No</div>
                  </div>
                </div>
                <div className={styles.buttonBlock}>
                  <div 
                    className={styles.priButton}
                    style={{
                      color: this.textColorByGamma(this.props.primaryColor),
                      backgroundColor: this.props.primaryColor
                    }}
                  >
                    UPDATE
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.accorHeader}>
              <div className={styles.accorHeaderTitle}>
                <div
                  className={styles.accorHeaderTitleIcon}
                  style={{
                    fill: this.props.formElemColor
                  }}
                >
                  <CRSIcon />
                </div>
                Common Reporting Standard (CRS)
              </div>
              <div className={styles.accorHeaderArrow}>
                <ArrowDownIcon />
              </div>
            </div>
          </div>
          {/* Submit */}
          <div className={styles.submitSection}>
            <div className={styles.buttonBlock}>
              <div 
                className={styles.disabledButton}
              >
                SUBMIT &#38; SIGN
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SDKPreview.propTypes = {
  id: PropTypes.string,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  formElemColor: PropTypes.string,
  logo: PropTypes.string
};

SDKPreview.defaultProps = {
  id: "",
  primaryColor: "#002659",
  secondaryColor: "#D71920",
  formElemColor: "#002659",
  logo: "data:image/png;base64,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"
};

export default SDKPreview;
